import { Validators } from '@angular/forms';
import { IGenCatForm, NgGencatSelectComponent } from '@ctti-dev/ng-gencat';

export const LOGIN_FORM_CONFIG: IGenCatForm = {
  pools: {
    component: NgGencatSelectComponent,
    customClass: 'col-sm-12',
    label: 'login.form.agency',
    placeholder: 'Selecciona una agència',
    multiple: 'single',
    size: 'small',
    options: [],
    validators: [Validators.required],
  },
};
